<template>
  <button
    v-if="toggle.printerPlugin"
    class="printer-help-button"
    @click="openPDFTutorial"
  >
    <md-tooltip md-direction="left">
      Clique aqui e saiba mais
    </md-tooltip>
    <svg-loader
      src="/static/images/icon-help-basic-purple.svg"
      class="mr-1"
    />
  </button>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PrinterHelpButton',
  computed: {
    ...mapGetters([
      'toggle',
      'webSocketStatus'
    ])
  },
  methods: {
    openPDFTutorial() {
      window.open('https://storageapoiob2bprd.blob.core.windows.net/printer-plugin/Manual_Instalacao_Plugin_Impressao_AOL20.pdf', '_blank')
    }
  },
}
</script>
<style lang="scss" scoped>
.printer-help-button {
  display: inline-flex;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;

  .md-icon {
    width: 22px;
    min-width: 22px;
    height: 22px;
    min-height: 22px;
    font-size: 22px;
    padding: 0 !important;
  }

  svg-loader {
    width: 22px;
    height: 22px;
  }
}
</style>
